/**
 * Lighting looks (concept L116–L120). 'morning' is v1's classic look (GDD §3.1); sunset and dusk are for v1.1.
 */
export interface Look {
  top: number;
  mid: number;
  hor: number;
  sunCol: number;
  sunDir: [number, number, number];
  sun: number;
  sunLight: number;
  hemiSky: number;
  hemiGround: number;
  hemi: number;
  fog: number;
  fogNear: number;
  fogFar: number;
  exposure: number;
  deep: number;
  shallow: number;
  foam: number;
  lamps: number;
  env: number;
}

export const LOOKS: Record<'morning' | 'sunset' | 'dusk', Look> = {
  morning: {
    top: 0x3c76b6,
    mid: 0x93bad8,
    hor: 0xe2eae6,
    sunCol: 0xfff0d0,
    sunDir: [-0.42, 0.74, -0.52],
    sun: 3.1,
    sunLight: 0xfff1dc,
    hemiSky: 0xbfd7ea,
    hemiGround: 0x4a5a36,
    hemi: 0.55,
    fog: 0xcfdcde,
    fogNear: 280,
    fogFar: 1300,
    exposure: 0.92,
    deep: 0x163f4d,
    shallow: 0x3f8984,
    foam: 0xf2f6f5,
    lamps: 0,
    env: 0.9,
  },
  sunset: {
    top: 0x3a5d86,
    mid: 0xdba77b,
    hor: 0xf7c48e,
    sunCol: 0xffb070,
    sunDir: [0.52, 0.2, -0.83],
    sun: 3.4,
    sunLight: 0xffc08a,
    hemiSky: 0xf3cfa8,
    hemiGround: 0x7a3a22,
    hemi: 0.95,
    fog: 0xe8b489,
    fogNear: 110,
    fogFar: 760,
    exposure: 0.88,
    deep: 0x173f42,
    shallow: 0x5c8a72,
    foam: 0xfff1de,
    lamps: 0.2,
    env: 0.8,
  },
  dusk: {
    top: 0x111a2c,
    mid: 0x3f3a5a,
    hor: 0xdc7a4e,
    sunCol: 0xff8a50,
    sunDir: [0.64, 0.1, -0.76],
    sun: 1.5,
    sunLight: 0xff9a66,
    hemiSky: 0x5a6484,
    hemiGround: 0x1e1a1c,
    hemi: 0.5,
    fog: 0x5c4858,
    fogNear: 150,
    fogFar: 950,
    exposure: 1.05,
    deep: 0x0c1622,
    shallow: 0x283847,
    foam: 0x9aa0a8,
    lamps: 2.2,
    env: 0.7,
  },
};
